import { useToastStore } from "@/stores/useToastStore";

const STORAGE_KEY = "izanagi.newChatEnvironmentSelection";

export interface StoredNewChatEnvironmentSelection {
	projectId: string | null;
	environmentId: string | null;
}

const EMPTY_SELECTION: StoredNewChatEnvironmentSelection = { projectId: null, environmentId: null };

function isNullableString(value: unknown): value is string | null {
	return value === null || typeof value === "string";
}

function parseSelection(raw: string | null): StoredNewChatEnvironmentSelection {
	if (raw === null) return EMPTY_SELECTION;
	const parsed: unknown = JSON.parse(raw);
	if (typeof parsed !== "object" || parsed === null) return EMPTY_SELECTION;
	const { projectId, environmentId } = parsed as Record<string, unknown>;
	if (!isNullableString(projectId) || !isNullableString(environmentId)) return EMPTY_SELECTION;
	return { projectId, environmentId };
}

/**
 * 新規チャットで最後に選んだプロジェクト・環境。ページ更新後も同じ選択から始められるようにする。
 * 保存値が無い・壊れている場合は未選択として扱い、既定の選択ロジックに任せる。
 */
export function readStoredNewChatEnvironmentSelection(): StoredNewChatEnvironmentSelection {
	try {
		return parseSelection(window.localStorage.getItem(STORAGE_KEY));
	} catch (err: unknown) {
		console.error("新規チャットの環境選択の読み込みに失敗しました", err);
		return EMPTY_SELECTION;
	}
}

/**
 * エラーハンドリング規約 (再スロー必須) の明示的な例外: localStorage が無効でも選択操作自体は
 * 有効なので、保存できなかったことだけをトーストで通知して続行する。
 */
export function writeStoredNewChatEnvironmentSelection(
	selection: StoredNewChatEnvironmentSelection,
): void {
	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
	} catch (err: unknown) {
		console.error("新規チャットの環境選択の保存に失敗しました", err);
		useToastStore.getState().show({
			type: "error",
			message: "エージェントの選択を保存できませんでした。次回は既定のエージェントが選ばれます。",
		});
	}
}
